import React, { FC, useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box } from '@altermaind/web/ui';
import { Slider } from '@/_shared/components/Slider';
import { Routes } from '@/_shared/constants/routes';
import { getMyContentsCall } from '../../state';
import { ContentsSkeleton } from '../ContentsSkeleton';
import { ContentToCard } from '../ContentToCard';

export const MyContents: FC = () => {
  const t = useTranslations('trainingHardSkills.sections.myContents');
  const navigate = useNavigate();
  const {
    execute: executeGetMyContents,
    loading: loadingGetMyContents,
    data,
  } = getMyContentsCall.hook();

  const onGoToListingPage = useCallback(() => {
    navigate(Routes.TrainingHardSkillsMyContents);
  }, [navigate]);

  useEffect(() => {
    executeGetMyContents({
      length: 10,
    });
  }, [executeGetMyContents]);

  return (
    <Box>
      {loadingGetMyContents ? <ContentsSkeleton halfHeightLayout={false} /> : null}
      {!loadingGetMyContents && data && data.length > 0 ? (
        <Slider.SliderBottomRightArrow
          title={t('title')}
          description={t('subTitle')}
          onGoToListingPage={{ onClick: onGoToListingPage, text: t('showAll') }}
        >
          {data?.map(content => (
            <ContentToCard content={content} key={content.id} />
          ))}
        </Slider.SliderBottomRightArrow>
      ) : null}
    </Box>
  );
};
